function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v15H0V7.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,15H1.071v-1.071h28.929v1.071ZM30,12.857H1.071v-1.071h28.929v1.071ZM30,10.714H1.071v-1.071h28.929v1.071ZM30,8.571H1.071v-1.071h28.929v1.071Z",
    style: {
      fill: "#c00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h15v9.107H0V7.5Z",
    style: {
      fill: "#006"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,21.429H0v-1.071h30v1.071ZM30,19.286H0v-1.071h30v1.071ZM30,17.143H0v-1.071h30v1.071Z",
    style: {
      fill: "#c00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375,9.107l.239,1.634.924-1.368-.496,1.576,1.426-.833-1.129,1.205,1.647-.132-1.54.596,1.54.596-1.647-.132,1.129,1.205-1.426-.833.496,1.576-.924-1.368-.239,1.634-.239-1.634-.924,1.368.496-1.576-1.426.833,1.129-1.205-1.647.132,1.54-.596-1.54-.596,1.647.132-1.129-1.205,1.426.833-.496-1.576.924,1.368.239-1.634ZM8.036,9.174c-1.442-.64-3.13.01-3.77,1.453-.64,1.442.01,3.13,1.453,3.77.738.327,1.58.327,2.318,0-1.442,1.035-3.451.705-4.485-.738-1.035-1.442-.705-3.451.738-4.485,1.118-.803,2.626-.803,3.746,0Z",
    style: {
      fill: "#fc0"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMy);
export default __webpack_public_path__ + "static/media/MY.242575adf21b3d740fa10cff875ed8fe.svg";
export { ForwardRef as ReactComponent };